import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Loader from '../../../../common/Loader';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import InternalResource from '../../../../common/resource/InternalResource';
import EnumStatus from '../../../../common/EnumStatus';
import { YANGO_DELIVERY_STATUS } from '../../../../../config/constants';

export const YangoClaimResource = ({ loading, yangoClaim }) => {
  let content;

  if (loading) content = <Loader />;
  else if (!yangoClaim) content = null;
  else {
    content = (
      <div style={{ marginTop: '20px' }}>
        <h3>Detalles Reparto Yango</h3>
        <ResourceProperty label="Precio:">
          {yangoClaim.price || '-'}
        </ResourceProperty>

        <ResourceProperty label="Estado:">
          <EnumStatus
            enumObject={YANGO_DELIVERY_STATUS}
            enumValue={yangoClaim.status}
          />
        </ResourceProperty>

        <InternalResource
          id={yangoClaim.id}
          createDate={yangoClaim.createDate}
          lastUpdate={yangoClaim.lastUpdate}
        />
      </div>
    );
  }

  return content;
};

YangoClaimResource.propTypes = {
  loading: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  yangoClaim: PropTypes.object,
};

YangoClaimResource.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ CargoUnit }) => ({
  yangoClaim: CargoUnit.Delivery.getIn([
    'current',
    'content',
    'yangoDeliveryClaim',
  ]),
  loading: !CargoUnit.Delivery.getIn(['yango', 'activity']).isEmpty(),
});

export default connect(mapStateToProps)(YangoClaimResource);
